const getters = {
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  userPoints: state => state.points.userPoints,
  tutorialUrl: state => state.user.tutorialUrl,
  customerConfig: state => state.user.customerConfig,
}
export default getters
